import React from 'react';
import styles from "./AboutMe.module.css";
import gabriel_aboutme from "../img/gabriel_aboutme.jpg";


export function AboutMe() {
    return (
        <div className={styles.containerAbout}>
                <img
                    className={`${styles.col} ${styles.imageAbout}`}  
                    width={285} 
                    height={300} 
                    src = {gabriel_aboutme} alt="About me"
                />
                <div className={`${styles.col} ${styles.textAbout}`}>
                    <p>
                        <strong>Gabriel Torres Morandi</strong> is a Venezuelan-Italian artist based in Germany whose work spans physical theatre, audiovisual arts, and performance.
                        His practice explores the intersection of artistic creation, community engagement, and contemporary performance.
                    </p>

                    <p>
                        He studied <strong>Physical Theatre</strong> at the <i>Folkwang University of the Arts</i> in Essen, Germany. For two years, he served as Artistic Director of the
                        <strong> National Theatre Company of Venezuela</strong>, and for a decade, he directed the <strong>Andróginos Foundation</strong>, dedicated to research and creation in the performing arts. He has also taught at the <strong>University of the Andes</strong> and the <strong>Experimental University of the Arts (UNEARTE)</strong> in Venezuela.
                    </p>

                    <p>
                        His works have been presented internationally and have received several awards, including the <strong>National Theatre Award</strong> from the Venezuelan Ministry of Culture for <strong>Best Direction (2011)</strong> for his play <i>Caverna</i>.
                    </p>

                    <p>
                        In Germany, he collaborates with the <strong>Theater Schießbühne</strong> company, where he serves as artistic director for productions funded by <strong>ChanceTanz / Aktion Tanz</strong>.
                    </p>

                    <p>
                        A review published in the journal of the <strong>Maestro J. M. Briceño Guerrero Association</strong> described him as:
                    </p>

                    <p>
                        <a className={styles.linkMagazine} href="https://www.jonuel-brigue.org/single-post/arte-22" target="_blank" rel="noopener noreferrer">
                            <em>“The cultural tsunami of stage artist Gabriel Torres Morandi.”</em>
                        </a>
                    </p>

                </div>
               

        </div> 
    )
}
